import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { UserService } from './core/user/user.service';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver {
    /**
     * Constructor
     */
    constructor(
        private readonly _userService: UserService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        // Fork join multiple API endpoint calls to wait all of them to finish
        return combineLatest([
            this._userService.get(),
            this._userService.getProfilePhoto()
        ]);
    }
}
